import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.css']
})
export class StarRatingComponent implements OnInit {
 @Input() score=0
 isZeroStar= false 
 isOneStar= false 
 isTwoStar= false 
 isThreeStar= false
 isFourStar= false
 isFiveStar= false
  constructor() { }

  ngOnInit(): void {
    this.isZeroStar = 0 <= this.score  && this.score < 10
    this.isOneStar = 10 <= this.score  && this.score < 30
    this.isTwoStar = 30 <= this.score  && this.score < 50
    this.isThreeStar = 50 <= this.score  && this.score < 70
    this.isFourStar = 70 <= this.score  && this.score < 90
    this.isFiveStar = 90 <= this.score  && this.score < 1010
  }

}
